module.exports = __webpack_public_path__ + "prod/1.42.2/img/obj_trading2x.79eab7e4.png";